import { ContentHeader, IconArrowRightRegular } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { Log } from '@common/log-manager';
import { useInitLikedProducts } from '@widgets/like-product';
import { VerticalProductCardWithItem } from '@common/product-card';
import { convertProductListToIdList, ImageCardComponentType, useProductCardEvents } from '@domains/storehome-common';

import { useImageCardService } from '../services/useImageCardService';

interface Props {
  log?: Partial<Log>;
  component: ImageCardComponentType;
}

export const ImageCardContainer = ({ log, component }: Props) => {
  const { header, common_image, product_list } = component;
  const { product_card_list, handleClickBanner, handleClickHeader } = useImageCardService({
    log,
    product_list,
  });
  const { onClick, onImpression, onLikeClick } = useProductCardEvents();

  useInitLikedProducts({
    data: product_card_list,
    convert: convertProductListToIdList,
  });

  return (
    <Root>
      <Top>
        <div onClick={(event) => handleClickHeader(event, header.button?.landing_url)}>
          <ContentHeader
            title={
              <>
                {header.title?.text}
                {header.subtitle?.text && (
                  <>
                    <br />
                    {header.subtitle.text}
                  </>
                )}
              </>
            }
            right={{
              type: 'icon-button',
              icon: IconArrowRightRegular,
            }}
          />
        </div>
        <ImageWrapper onClick={(event) => handleClickBanner(event, header.button?.landing_url)}>
          <Image src={common_image?.url.normal} alt='image_banner_list main image' />
        </ImageWrapper>
      </Top>
      <List>
        {product_card_list.map((item, index) => (
          <ProductCardWrapper key={item.catalog_product_id}>
            <VerticalProductCardWithItem
              item={item}
              size='small'
              onClick={(item, event) => {
                return onClick(event, item, index, log && { ...log, object_idx: index });
              }}
              onLikeClick={(isLiked, item) => {
                return onLikeClick(isLiked, item, index, log && { ...log, object_idx: index });
              }}
              onImpression={(item) => {
                return onImpression(item, index, log && { ...log, object_idx: index });
              }}
            />
          </ProductCardWrapper>
        ))}
      </List>
    </Root>
  );
};

const Root = styled.section``;

const Top = styled.div`
  cursor: pointer;
`;

const ImageWrapper = styled.div`
  padding: 0 16px;
`;

const Image = styled.img`
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;
`;

const List = styled.div`
  display: flex;
  padding: 2px 16px 0;
  justify-content: space-between;
  gap: 2px;
`;

const ProductCardWrapper = styled.div`
  flex: 1;
`;
